import { CoreIconButton, OverflowText } from "@verity/components/core";
import BackButton from "../../../../../images/reports/backButton.svg?react";
import i18n from "../../../../../i18n";
import { Stack } from "@mui/material";

type ResultViewBackButtonProps = {
	onBackButtonClick: () => void;
	backLabel: string;
	showBackButton?: boolean;
};

export default function ResultViewBackButton({
	onBackButtonClick,
	backLabel,
	showBackButton,
}: ResultViewBackButtonProps) {
	return (
		<Stack direction={{ xs: "row" }} alignItems="center" spacing={0.8}>
			{showBackButton && (
				<CoreIconButton
					variant="plain"
					onClick={onBackButtonClick}
					sx={{ padding: "4px" }}
					aria-label={i18n.t("result.components.resultsPage.proctoringResultsHeaderTSX.backButtonAriaLabel")}
				>
					<BackButton />
				</CoreIconButton>
			)}

			<OverflowText
				variant="h1"
				fontWeight={600}
				fontSize="15px"
				style={{
					flexGrow: 1,
					maxWidth: "300px",
				}}
			>
				{backLabel}
			</OverflowText>
		</Stack>
	);
}
